import ChangePasswordDialog from "features/auth/ChangePasswordDialog";

interface FirstLoginPasswordChangeDialogProps {
  open: boolean;
  onPasswordChanged: () => void;
}

const FirstLoginPasswordChangeDialog: React.FC<
  FirstLoginPasswordChangeDialogProps
> = ({ open, onPasswordChanged }) => {
  const handlePasswordChangeSuccess = () => {
    // Password was successfully changed
    onPasswordChanged();
  };

  return (
    <ChangePasswordDialog
      open={open}
      onClose={() => {
        // Ez nem fog meghívódni, mert mandatory=true
      }}
      onSuccess={handlePasswordChangeSuccess}
      mandatory={true}
    />
  );
};

export default FirstLoginPasswordChangeDialog;
